import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Usuario } from '../index';
import { UsuarioService } from '../service/usuario/usuario.service';


@Injectable()
export class UsuarioResolve implements Resolve<Usuario> {

    constructor(
        private usuarioService : UsuarioService
    ) {}

    resolve(route: ActivatedRouteSnapshot) : Observable<Usuario> {

        let token = route.paramMap.get('token');

        if (token) {
            return this.usuarioService.obterDadosUsuarioPorToken(token);
        } else {
            let currentUser = JSON.parse(localStorage.getItem("currentUser"));
            let id = currentUser.id;
            let organizacaoId = currentUser.organizacaoId;
            return this.usuarioService.visualizarProprioUsuarioOrgPorId(id, organizacaoId);
        }
    }
}
